import React, { createContext, useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';


export type KeyboardLayout = 'numeric' | 'default'

type OpenArgs = {
  inputRef: HTMLInputElement,
  input: React.ReactElement,
  keyboardLayout?: KeyboardLayout,
  title?: string,
}

type Context = {
  opened: boolean
  layout?: KeyboardLayout
  inputRef?: HTMLInputElement
  input?: React.ReactElement
  title?: string
  open: (args: OpenArgs) => void
  close: () => void
}

const KeyboardContext = createContext<Context | null>(null)

type Props = {
  children: React.ReactElement | React.ReactElement[],
}

export const KeyboardProvider = (props: Props): React.ReactElement => {
  const isKiosk = useSelector((state: RootState) => state.app.isKiosk)

  const [opened, setOpened] = useState(false)
  const [inputRef, setInputRef] = useState<HTMLInputElement>()
  const [input, setInput] = useState<React.ReactElement>()
  const [layout, setLayout] = useState<KeyboardLayout>('default')
  const [title, setTitle] = useState<string | undefined>(undefined)

    
  const providerValue = {
    opened,
    inputRef,
    input,
    layout,
    title,
    open: (args: OpenArgs) => {
      if(isKiosk) {
        setInputRef(args.inputRef)
        setInput(args.input)
        setLayout(args.keyboardLayout ?? 'default')
        setTitle(args.title)
        setOpened(true)
      }
    },
    close: () => {
      setOpened(false)
      setInputRef(undefined)
    },
  }

  return (
    <KeyboardContext.Provider value={providerValue}>
      { props.children }
    </KeyboardContext.Provider>

  );
}

const useKeyboard = (): Context => {
  const context = useContext(KeyboardContext);

  if (!context) {
    throw new Error('useKeyboard must be used within a KeyboardProvider');
  }

  return context;
};

export default useKeyboard;
